import { FC } from 'react';
import { DateCellProps } from './DateCell.types';
import { Flex, Text, Pill } from '@/_components';
import { getDate, getIsOneWeekAway, getIsPastDate } from '@/_utils/dates';

export const DateCell: FC<DateCellProps> = ({ date, isDue }) => {
  const isPastDue: boolean = getIsPastDate(date);
  const isOneWeekAway: boolean = getIsOneWeekAway(date);
  const formattedDate: string = getDate(date);

  return (
    <Flex isColumn={true}>
      <Flex isInline={true} isColumn={true} gap={2}>
        <Text type="tiny">{formattedDate}</Text>
        {isDue && isPastDue && (
          <Flex isInline={true}>
            <Pill
              size="small"
              intent="danger"
              label="Past Due"
              iconLeft="warning"
            />
          </Flex>
        )}
        {isDue && !formattedDate && <Text type="tiny">-</Text>}
      </Flex>
      {isOneWeekAway && (
        <Text type="tiny" color="caution">
          Next Week
        </Text>
      )}
    </Flex>
  );
};
